import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { lazy, Suspense } from "react";
import Header from "./Layout/Header";
import Footer from "./Layout/Footer";
import { ThemeProvider } from "@mui/material/styles";
import Home from "./Home/Home";
import MenuOrder from "./Menu/MenuOrder";
import theme from "./Theme";
import Stack from "@mui/material/Stack";
import { CircularProgress, Fab, Box } from "@mui/material";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const Contact = lazy(() => import("./Contact/Contact"));
const Catering = lazy(() => import("./Menu/Catering"));
const Franchise = lazy(() => import("./Franchise/Franchise"));

const PageLoader = () => (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
    <CircularProgress size={48} sx={{ color: "#20141e" }} />
  </Box>
);

const App = () => {
  const location = useLocation();
  const isMenuPage = location.pathname === "/menu";
  return (
    <div id="app-wrapper">
      <ThemeProvider theme={theme}>
        <Stack
          sx={{
            display: "flex",
            height: "inherit",
            backgroundColor: "background.paper",
            width: "100vw",
            minHeight: "100vh",
            justifyContent: "space-between",
          }}
          spacing={2}
        >
          <Header />
          <section>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/menu" element={<MenuOrder />} />
                <Route path="/catering" element={<Catering />} />
                <Route path="/order-now" element={<Navigate to="/menu" replace />} />
                <Route path="/franchise" element={<Franchise />} />
              </Routes>
            </Suspense>
            {!isMenuPage && (
              <Fab
                component="a"
                variant="extended"
                aria-label="Order Now - go to menu"
                style={{
                  margin: 0,
                  top: "auto",
                  right: 20,
                  bottom: 20,
                  left: "auto",
                  position: "fixed",
                  fontStyle: "normal",
                  background: "green",
                  color: 'white',
                  fontWeight: "bold",
                }}
                href="/menu"
              >
                <ShoppingCartIcon />
                Order Now
              </Fab>
            )}
          </section>
          <Footer />
        </Stack>
      </ThemeProvider>
    </div>
  );
};
export default App;
